var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportIndex"},[_vm._l((_vm.All),function(item,index){return _c(item.name,{key:index,tag:"component"})}),_c('div'),(_vm.empty)?_c('div',[_c('van-skeleton',{attrs:{"title":"","row":10}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }